import apiServiceNew from './apiService.new';

const campaignPagePath = 'campaignPage';

const update = pageInfo => apiServiceNew.put(campaignPagePath, pageInfo);

const get = token => apiServiceNew.put(`${campaignPagePath}/${token}`);

export default {
	update,
	get
};